// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1f6Vj","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3bwOG","obliqueLine":"membershipbadge_obliqueLine__1zsJy"};